import React, { useState } from 'react'
import { startAdminSession } from '../data/adminSession'

export default function Login({ navigate }) {
  const [email, setEmail] = useState('admin@difan.co.kr')
  const [password, setPassword] = useState('')

  const submit = (event) => {
    event.preventDefault()
    startAdminSession(email)
    navigate('/dashboard')
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand"><div className="admin-brand-mark">D</div><div><strong>difan</strong><span>ADMIN</span></div></div>
        <div className="login-heading"><span>ADMIN CONSOLE</span><h1>관리자 로그인</h1><p>DIFAN 운영 관리자 전용 화면입니다.</p></div>
        <form onSubmit={submit}>
          <label>이메일<input required type="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
          <label>비밀번호<input required type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="비밀번호를 입력하세요" /></label>
          <button type="submit" className="button primary wide">로그인</button>
        </form>
        <p className="login-note">현재는 화면 검수용 Mock 인증입니다. 실제 관리자 인증과 권한 관리는 difan-api 연결 시 적용합니다.</p>
      </div>
    </div>
  )
}
